import { z } from 'zod'

export const COACHING_SHELL_CERTIFICATE_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellCertificateResponseSchema = z.unknown()
export type CoachingShellCertificateResponse = z.infer<typeof coachingShellCertificateResponseSchema>
